module.exports = __webpack_public_path__ + "img/pasta-2.a47d0329.jpg";